export const ASSET = {
  // App Assets
  performance: 'performance',
  widgets: 'widgets',
  audience: 'audience',
  aso: 'aso',
  finance_performance: 'finance_performance',
  finance_widgets: 'finance_widgets',
  forecasts: 'forecasts',
  advanced_time_series: 'advanced_time_series',
  app_details: 'app_details',
  // Pub Assets
  countries: 'countries',
  publisher: 'publisher',
  sdks: 'sdks',
  time_series: 'time_series',
  top_apps: 'top_apps',
  // Company Assets
  kpi_spotlight: 'kpi_spotlight',
  mpi_spotlight: 'mpi_spotlight',
  drivers: 'drivers',
  company_data: 'company_data',
  pub_contribution: 'pub_contribution',
};

export const SUB_ASSETS = {
  app_details: ['about_data', 'app_about', 'installed_sdks', 'x_ray_tags'],
};

export const QV_TYPE = {
  app: 'app',
  publisher: 'publisher',
  company: 'company',
};
